module.exports = __webpack_public_path__ + "static/media/Rolling.9586e57d.gif";